import { Controller } from "@hotwired/stimulus"

/**
 * Media Preview Controller
 *
 * Opens a full-screen overlay to preview images.
 * Closes on click or Escape key.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["image", "overlay"]

  declare readonly imageTarget: HTMLImageElement
  declare readonly overlayTarget: HTMLElement
  declare readonly hasOverlayTarget: boolean

  open() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnEscape(event: KeyboardEvent) {
    if (event.key === "Escape") this.close()
  }
}
